<template>
    <div class="rest_list stop_list">
        <div class="rest_list_container">
            <div class="order__heading_block_row" :class="classHeadingRow">
                <div class="order__heading_block_row_left">
                    <button class="order__heading_back_arrow" @click.prevent="clickBackArrow">
                        <svg>
                            <use xlink:href="/icons/base.svg#back_arrow"></use>
                        </svg>
                    </button>
                    <div class="rest_list__item_rest_name">
                        {{ restStopListTitle }}
                    </div>
                </div>
                <div class="order__heading_block_row_right">
                    <button class="order__heading_back_arrow" @click.prevent="clickSort">
                        <svg>
                            <use xlink:href="/icons/base.svg#sort"></use>
                        </svg>
                    </button>
                    <button v-if="isStopListMenu" class="order__heading_back_arrow" @click.prevent="clickFilter">
                        <svg>
                            <use xlink:href="/icons/base.svg#filter"></use>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="rest_list_container">
            <div class="rest_list__header">
                <div class="rest_list__header_container">
                    <rest_list_header_item
                        v-for="item in menuStopList"
                        :key="'rest_list_header_item_' + item.id"
                        :item="item"
                        @select_item_header="selectItemHeader"
                    />
                </div>
            </div>
        </div>
        <div v-if="!isStopListMenu" class="rest_list__search">
            <search_block
                :key="'search_block_menu_stop_list'"
                :placeholderText="placeholderTextSearch"
                :searchDataDefault="searchDataMenu"
                @search_input_data="searchInputData"
            />
            <div class="rest_list__search_switch">
                <div class="rest_list__search_switch_img">
                    <switch_block
                        :key="'switch_block_'"
                        :switchStatus="isSearchModifier"
                        :width="52"
                        :height="32"
                        @click_switch="clickSearchSwitch"
                    />
                </div>
                <div class="rest_list__search_switch_label"  @click.prevent="clickSearchSwitch">
                    {{ __t('O.SEARCH_BY_MODIFIER') }}
                </div>
            </div>
        </div>
        <div class="rest_list__scroll products">
            <div ref="blockScroll" class="rest_list__scroll_container">
                <spinner
                    v-if="isLoadMenu"
                    :height="'100px'"
                    :width="'10px'"
                />
                <rest_list_item_product
                    v-else
                    v-for="item in productsListMenu"
                    :key="'rest_list_item_product_' + itemProductId(item)"
                    :prodItem="item"
                    :isStopListItem="isStopListMenu"
                    @open_modal_product_locations="openModalProductLocations"
                />
            </div>
            <button_up
                :key="'button_up_products'"
                :isShow="isShowButtonUp"
                @click_up="clickUpButton"
            />
            <counter_list
                :key="'counter_list'"
                :isShow="isShowCounter"
                :counterCurrent="counterCurrent"
                :counterTotal="stopListProductsTotal"
            />
        </div>

        <div class="rest_list__buttons">
            <div class="rest_list__buttons_container">
                <button class="rest_list__buttons_button_off" @click.prevent="clickSelectAll">
                    <div class="rest_list__buttons_button_off_text">
                        {{ __t('O.SELECT_ALL') }}
                    </div>
                </button>
                <button class="rest_list__buttons_button_on" @click.prevent="clickSelectStopListProducts">
                    <div class="rest_list__buttons_button_on_text">
                        {{ __t('O.NEXT') }}
                    </div>
                </button>
            </div>
        </div>
    </div>


    <modal
        v-if="statusModalFilter"
        :key="'modal_window_filter'"
    >
        <template v-slot:content>
            <modal_filter
                :key="'modal_filter'"
                :filterList="filterList"
                :nameOperation="'modal_filter'"
                @close="closeFilter"
                @apply="applyFilter"
            />
        </template>
    </modal>

    <modal
        v-if="statusModalProductLocations"
        :key="'modal_window_filter'"
    >
        <template v-slot:content>
            <modal_filter
                :key="'modal_filter'"
                :filterList="filterListProduct"
                :nameOperation="'modal_product_locations'"
                :productSelect="productSelect"
                @close="closeModalProductLocations"
                @apply="applyFilter"
                @remove_select_product="removeSelectProduct"
            />
        </template>
    </modal>

</template>

<script>

import rest_list_header_item from "../../RestListHeaderItem.vue";
import search_block from "../../SearchBlock.vue";
import modal from "../../../modal/Modal.vue";
import modal_filter from "../../../modal/filter/ModalFilter.vue";
import {changeBody} from "../../../../mixins/changeBody";
import spinner from "../../../loader/Spinner.vue";
import switch_block from "../../SwitchBlock.vue";
import {createHelpers} from "vuex-map-fields";
import burger_menu from "../../../heading/BurgerMenu.vue";
import {screenSize} from "../../../../mixins/screenSize";
import spinner_button from "../../../loader/SpinnerButton.vue";
import {colorFunctions} from "../../../../mixins/colorFunctions";
import {mouseMoveScroll} from "../../../../mixins/mouseMoveScroll";
import rest_list_item_product from "./RestListItemProduct.vue";
import menu_orders from "../../../menu/order/MenuOrders.vue";
import {scrollFunctions} from "../../../../mixins/scrollFunctions";
import button_up from "../../../ButtonUp.vue";
import counter_list from "../../../CounterList.vue";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})
const {mapFields: mStopList} = createHelpers({
    getterType: 'stop_list/getStopListField',
    mutationType: 'stop_list/updateStopListField',
})

export default {
    name: "products_select_stop_list",
    props: {
        restId: {
            type: String,
            required: true,
        },
        backState: {
            type: String,
            required: false,
            default: '0'
        },
    },
    emits: [],
    mixins: [changeBody, screenSize, colorFunctions, mouseMoveScroll, scrollFunctions],
    components: {
        menu_orders,
        spinner_button,
        burger_menu,
        rest_list_header_item,
        search_block,
        modal,
        modal_filter,
        spinner,
        switch_block,
        rest_list_item_product,
        button_up,
        counter_list
    },
    data() {
        return {
            showOrdersMenu: false,
            statusModalFilter: false,
            isLoadLocations: true,
            locationsList: [],
            switchAllStatus: false,
            showBlockButtons: false,
            classScrollElementMouseMove: '.rest_list__header',
            scrollElementMouseMove: null,
            restStopList: null,
            menuStopList: [
                {id: 1, name: 'Стоп-Лист', const: 'O.STOP_LIST', nameAction: 'stop_list', isSelect: true},
                {id: 2, name: 'Меню', const: 'O.MENU', nameAction: 'menu', isSelect: false},
            ],
            isLoadMenu: false,
            productsListMenuNoFilter: [],
            productsListMenu: [],
            activeItemMenu: {id: 1, name: 'Стоп-Лист', nameAction: 'stop_list', isSelect: true},
            filterList: [],
            filterListProduct: [],
            searchDataMenu: '',
            statusModalProductLocations: false,
            productSelect: null,
            counterLabel: '500',
            counterCurrent: 0,
            counterTotal: 0,
            isSearchModifier: false,
        }
    },
    beforeMount() {
        EventBus.$on('load_stop_list_data', this.loadStopListData);
        EventBus.$on('load_search_products_menu', this.loadSearchProductsMenu);
        EventBus.$on('stop_list_products_by_rest_load', this.stopListProductsLoad);
        this.restStopList = this.posRestaurantsList.find(item => item.id === parseInt(this.restId));
        if (parseInt(this.backState) !== 1) {
            this.isLoadMenu = true;
            this.$store.dispatch('stop_list/STOP_LIST_DATA', this.restId);
        } else {
            this.loadStopListData();
        }
    },
    beforeUnmount() {
        EventBus.$off('load_stop_list_data', this.loadStopListData);
        EventBus.$off('load_search_products_menu', this.loadSearchProductsMenu);
        EventBus.$off('stop_list_products_by_rest_load', this.stopListProductsLoad);
        this.removeListenerBlockScroll();
    },
    methods: {
        clickUpButton() {
            if (this.$refs.blockScroll) {
                this.$refs.blockScroll.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                })
            }
        },
        stopListProductsLoad() {
            this.addListenerBlockScroll();
        },
        removeListenerBlockScroll() {
            if (this.$refs.blockScroll) {
                this.$refs.blockScroll.removeEventListener('scroll', this.calculateScrollPercentage);
            }
        },
        addListenerBlockScroll() {
            if (this.$refs.blockScroll) {
                this.$refs.blockScroll.addEventListener('scroll', this.calculateScrollPercentage);
            }
        },
        calculateScrollPercentage() {
            if (this.$refs.blockScroll) {
                this.blockScrollPercentScrolled = (this.$refs.blockScroll.scrollTop / (this.$refs.blockScroll.scrollHeight - this.$refs.blockScroll.clientHeight)) * 100;
                this.counterCurrent = Math.ceil((this.$refs.blockScroll.scrollTop + this.$refs.blockScroll.clientHeight) / this.stopListProductsTotalSizeScrollBlock * this.stopListProductsTotal);
                if (this.counterCurrent > this.stopListProductsTotal) {
                    this.counterCurrent = this.stopListProductsTotal;
                }
                if (this.blockScrollPercentScrolled > 50 && this.stopListProductsLoadCount <= this.stopListProductsTotal) {
                    this.removeListenerBlockScroll();
                    const paramsStopList = {
                        "list": {"limit_start": this.stopListProductsLoadCount, "limit": this.stopListChunkSize}
                    }
                    this.$store.dispatch('stop_list/STOP_LIST_PRODUCTS_BY_REST_LOAD', paramsStopList);
                }
            }
        },
        removeSelectProduct(filterList) {
            const checkLocationsId = filterList.filter(item => item.isCheckProductStopList).map(item => item.id.toString());
            if (this.productSelect.locations && checkLocationsId.length !== 0) {
                this.productSelect.locations = this.productSelect.locations.filter(item =>
                    !checkLocationsId.includes(item.toString())
                )
            }
            if (this.productSelect.locations.length === 0) {
                this.stopListProducts = this.stopListProducts.filter(item => item !== this.productSelect);
                this.productsListMenuNoFilter = this.productsListMenuNoFilter.filter(item => item !== this.productSelect);
            }
            filterList.forEach(item => item.isCheckProductStopList = false);
            this.getProductsListMenu();
        },
        closeModalProductLocations() {
            this.statusModalProductLocations = false;
        },
        openModalProductLocations(prodItem) {
            this.productSelect = prodItem;
            this.filterListProduct = this.filterList.filter(item =>
                prodItem.locations.some(locId =>
                    parseInt(locId) === parseInt(item.id)
                )
            )
            this.statusModalProductLocations = true;
        },
        itemProductId(item) {
            if (item.id) {
                return item.id;
            }
            if (item.product.id) {
                return item.product.id;
            }
            return '';

        },
        clickSearchSwitch() {
            this.isSearchModifier = !this.isSearchModifier;
            this.searchInputData(this.searchDataStopListRest);
        },
        loadStopListData() {
            this.activeItemMenu = this.menuStopList.find(item => item.isSelect);
            this.clickStopListHeaderMenu();
            this.isLoadMenu = false;
        },
        clickStopListHeaderMenu() {
            if (this.activeItemMenu && this.activeItemMenu.nameAction === 'stop_list') {
                this.addListenerBlockScroll();
                this.filterList = this.stopListProductsFilter;
                this.productsListMenuNoFilter = this.stopListProducts;
                this.getProductsListMenu();
            } else {
                this.removeListenerBlockScroll();
                this.filterList = this.searchProductsMenuFilter;
                this.productsListMenuNoFilter = this.searchProductsMenuStopList;
                this.searchDataMenu = this.searchDataStopListRest;
                this.getProductsListMenu();
            }
        },
        getProductsListMenu() {
            if (this.isStopListMenu && this.filterLocationsId.length !== 0) {
                this.productsListMenu = this.productsListMenuNoFilter.filter(obj => {
                    if (obj.locations && Array.isArray(obj.locations)) {
                        return obj.locations.some(id => {
                            return this.filterLocationsId.includes(parseInt(id))
                        })
                    }
                    return false;
                });
                return;
            }
            this.productsListMenu = this.productsListMenuNoFilter;
        },
        clickSelectStopListProducts() {
            const selectProducts = this.productsListMenu.filter(item => item.isCheck);
            this.$store.dispatch('stop_list/SET_SELECT_PRODUCTS_STOP_LIST', selectProducts);
            this.$router.push({path: '/locations', name: 'LocationsStopList'})
        },
        clickBackArrow() {
            this.$router.push({path: '/rest', name: 'RestStopList'});
        },
        selectItemHeader(itemHeader) {
            this.activeItemMenu = itemHeader;
            this.menuStopList.forEach(item => item.isSelect = item === this.activeItemMenu);
            this.clickStopListHeaderMenu();
        },
        loadSearchProductsMenu() {
            this.productsListMenuNoFilter = this.searchProductsMenuStopList;
            this.getProductsListMenu();
            this.isLoadMenu = false;
        },
        searchInputData(searchData) {
            if (searchData.length <= 2) {
                this.isLoadMenu = false;
                this.productsListMenu = [];
                return;
            }
            this.isLoadMenu = true;
            this.$store.dispatch('stop_list/SEARCH_PRODUCTS_MENU', {
                searchData: searchData,
                isSearchModifier: this.isSearchModifier,
                actionName: 'searchProductsMenu',
                restId: this.restId,
            });
        },
        compareTitles(a, b) {
            if (a.product && a.product.title && b.product && b.product.title) {
                const nameA = a.product.title.toLowerCase();
                const nameB = b.product.title.toLowerCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
            }
            return 0;
        },
        clickSort() {
            this.productsListMenu.sort(this.compareTitles);
            this.getProductsListMenu(this.productsListMenu);
        },
        clickFilter() {
            this.statusModalFilter = true;
        },
        closeFilter() {
            this.statusModalFilter = false;
        },
        clickSelectAll() {
            this.productsListMenu.forEach(item => item.isCheck = true);
        },
        applyFilter() {
            this.applyFilterList();
            this.closeFilter();
        },
        applyFilterList() {
            this.getProductsListMenu(this.productsListMenu);
        }
    },
    computed: {
        ...mUser([
            'user',
            'errorMessageUser',
        ]),
        ...mOrders([
            'posRestaurantsList',
            'selectAggregatorsLocationsRest',
            'selectLocationsProducts',
        ]),
        ...mStopList([
            'stopListProducts',
            'searchProductsMenuStopList',
            'searchDataStopListRest',
            'stopListProductsFilter',
            'searchProductsMenuFilter',
            'stopListProductsTotal',
            'stopListProductsLoadCount',
            'stopListChunkSize',
            'stopListProductsTotalSizeScrollBlock',
            'activeItemStopListGroups',
        ]),
        placeholderTextSearch() {
            return `${this.__t('O.FOOD_SEARCH')}`;
        },
        restStopListTitle() {
            if (this.restStopList && this.restStopList.title) {
                return this.restStopList.title;
            }
            return '';
        },
        isStopListMenu() {
            if (this.activeItemMenu.nameAction === 'stop_list') {
                return true;
            }
            return false;
        },
        filterLocationsId() {
            return this.filterList
                .filter(item => item.isCheckSave === true)
                .map(item => item.id)
        },
        isShowButtonUp() {
            if (this.blockScrollPercentScrolled > 50 && this.activeItemMenu.id === 1) {
                return true;
            }
            return false;
        },
        isShowCounter() {
            if (this.blockScrollPercentScrolled > 20 && this.activeItemMenu.id === 1) {
                return true;
            }
            return false;
        },
        classHeadingRow() {
            if (this.activeItemStopListGroups.id === 2) {
                return 'without_back';
            }
            return '';
        }
    },
}
</script>
